import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import {
  productTaxonomyDisplayOptions,
  productTaxonomyTypeOptions,
} from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/TryOnWidgetConfigurationPage/constants'

import ProductTaxonomyIdsField from './ProductTaxonomyIdsField/ProductTaxonomyIdsField'
import * as Styles from './styles'

const ProductOptions = ({
  productTaxonomyDisplay,
  setProductTaxonomyDisplay,
  productTaxonomyType,
  setProductTaxonomyType,
  productTaxonomyIds,
  setProductTaxonomyIds,
  productCategories,
  productCollections,
}) => {
  const { t } = useTranslation()

  const handleProductTaxonomyDisplayChange = e => setProductTaxonomyDisplay(e.target.value)
  const handleProductTaxonomyTypeChange = e => setProductTaxonomyType(e.target.value)

  return (
    <Styles.Container>
      <Text type="titleS">{t('Opciones de producto')}</Text>
      <ComboBox
        label={t('Mostrar para')}
        menuItems={[
          { label: t('Todos los productos'), value: productTaxonomyDisplayOptions.all },
          { label: t('Productos seleccionados'), value: productTaxonomyDisplayOptions.included },
          { label: t('Todos los productos no excluidos'), value: productTaxonomyDisplayOptions.excluded },
        ]}
        value={productTaxonomyDisplay}
        handleChange={handleProductTaxonomyDisplayChange}
        fullWidth
      />
      {productTaxonomyDisplay !== productTaxonomyDisplayOptions.all && (
        <>
          <ComboBox
            label={t('Mostrar por')}
            menuItems={[
              { label: t('Categoría'), value: productTaxonomyTypeOptions.category },
              { label: t('Collection'), value: productTaxonomyTypeOptions.collection },
              { label: t('Tag'), value: productTaxonomyTypeOptions.tag },
            ]}
            value={productTaxonomyType}
            handleChange={handleProductTaxonomyTypeChange}
            fullWidth
          />
          <ProductTaxonomyIdsField
            productTaxonomyType={productTaxonomyType}
            productTaxonomyDisplay={productTaxonomyDisplay}
            productTaxonomyIds={productTaxonomyIds}
            setProductTaxonomyIds={setProductTaxonomyIds}
            productCategories={productCategories}
            productCollections={productCollections}
          />
        </>
      )}
    </Styles.Container>
  )
}

export default ProductOptions
